import isVisible from 'ACCESSIBILITY/isVisible';

const selectors = {
  iframe: '#klaviyo-bis-iframe',
  modal: '#klaviyo-bis-modal',
  trigger: '.klaviyo-bis-trigger',
  closeButton: '.klaviyo-bis-close',
  successMessage: '#completed_message',
  variantSelect: '#variant_select',
  emailInput: '#email',
};

const fixModalAccessibility = {
  init(iframe) {
    this.iframe = iframe;
    const iframeDoc = this.iframe.contentWindow.document;

    const modal = iframeDoc.querySelector(selectors.modal);

    if (!modal) return;

    this.modal = modal;
    this.document = iframeDoc;
    this.trigger = document.querySelector(selectors.trigger);
    this.form = this.modal.querySelector('form');
    this.closeButton = this.modal.querySelector(selectors.closeButton);
    this.successMessage = this.modal.querySelector(selectors.successMessage);
    this.focusableElements = this.modal.querySelectorAll('button, input, select, a');
    this.variantSelect = this.modal.querySelector(selectors.variantSelect);
    this.emailInput = this.modal.querySelector(selectors.emailInput);
    this.keyboardHandler = this.keyboardHandler.bind(this);

    // Add observer to listen for success message
    this.successObserver = new MutationObserver(() => {
      if (!isVisible(this.successMessage)) return;

      const { innerHtml } = this.successMessage;
      this.successMessage.innerHtml = '';
      this.successMessage.innerHtml = innerHtml;
    });

    this.updateCloseButton();
    this.enableFocusManagement();
    this.addEmailRequiredAttribute();
    this.addLiveRegion();
    this.addFieldLabels();

    this.successObserver.observe(this.successMessage, {
      attributes: true,
      attributeFilter: ['style'],
    });
  },
  enableFocusManagement() {
    if (!this.closeButton) return;

    this.closeButton.focus();
    this.modal.addEventListener('keydown', this.keyboardHandler);
  },
  addEmailRequiredAttribute() {
    if (!this.form) return;

    const emailInput = this.form.querySelector('#email');
    emailInput.setAttribute('required', true);
  },
  addFieldLabels() {
    if (this.variantSelect) {
      this.variantSelect.setAttribute('aria-label', 'Variant');
    }

    if (this.emailInput) {
      this.emailInput.setAttribute('aria-label', 'Email (required)');
    }
  },
  addLiveRegion() {
    if (!this.form) return;

    this.form.setAttribute('aria-live', 'polite');
  },
  keyboardHandler(e) {
    const focusable = Array.from(this.focusableElements).filter((element) => {
      return isVisible(element);
    });

    const firstFocusable = focusable[0];
    const lastFocusable = focusable[focusable.length - 1];

    if (e.keyCode === 9) {
      if (e.shiftKey && this.document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && this.document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  },
  updateCloseButton() {
    if (!this.closeButton) return;

    this.closeButton.setAttribute('aria-label', 'Close modal');
  },
  unload() {
    this.successObserver.disconnect();
    this.modal.removeEventListener('keydown', this.keyboardHandler);
  },
};

const addVisibilityObserver = (iframe) => {
  const iframeObserver = new MutationObserver(() => {
    if (isVisible(iframe)) {
      fixModalAccessibility.init(iframe);
    } else {
      fixModalAccessibility.unload();
      fixModalAccessibility.trigger.focus();
    }
  });

  iframeObserver.observe(iframe, {
    attributes: true,
    attributeFilter: ['style'],
  });
};

// Set up mutation observer to listen for iframe addition to DOM
const observer = new MutationObserver((mutations, me) => {
  const iframe = document.querySelector(selectors.iframe);
  if (iframe) {
    addVisibilityObserver(iframe);
    me.disconnect(); // stop observing
  }
});

// And start observing
observer.observe(document, {
  childList: true,
  subtree: true,
});
